import { getPrefilledDataQueryParams, getPrefilledSignupData } from '../flow-settings/prefillDataSelectors';
import { bulkUpdate, prefillDataStored, stampPrefilled } from '../store/signup-data/action-creators';
export const prefillEmbeddedSignupData = data => dispatch => {
  const prefills = getPrefilledSignupData(data);
  const dataIsPopulated = Object.keys(prefills).length !== 0;
  if (dataIsPopulated) {
    dispatch(bulkUpdate(prefills));
    dispatch(stampPrefilled(prefills));
    dispatch(prefillDataStored());
  }
};
export const prefillQueryParamSignupData = () => dispatch => {
  const prefills = getPrefilledDataQueryParams();
  const dataIsPopulated = Object.keys(prefills).length !== 0;
  if (dataIsPopulated) {
    dispatch(bulkUpdate(prefills));
    dispatch(stampPrefilled(prefills));
    dispatch(prefillDataStored());
  }
};